<template>
    <img src="https://via.placeholder.com/300x300.png" />
</template>
<script>
export default {
  name: 'Image',
  props: {
    src: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/html/HtmlImage.vue